export enum GpsAction {
    AddTrackingNumber   = -1,
    AddTrackingComment  = 9,
    AddGpsLink          = 1,
    AddGpsNumber        = 2,
    MarkActive          = 8,
    MarkCenterReceived  = 3,
    MarkShippedBack     = 5,
    MarkNeedsReturned   = 4,
    MarkNkrReceived     = 7,    
    ViewGpsCentral      = 10,
    MarkedLost            = 11
}